export function generatePrice(
  total_project_power,
) {
  let power = total_project_power;
  let price = 0;

  if (power >= 0 && power <= 5) {
    price = 399.0;
  } else if (power > 5 && power <= 10) {
    price = 499.0;
  } else if (power > 10 && power <= 20) {
    price = 799.0;
  } else if (power > 20 && power <= 30) {
    price = 1299.0;
  } else if (power > 30 && power <= 50) {
    price = 1499.0;
  } else if (power > 50 && power <= 75) {
    price = 1799.0;
  } else if (power > 75) {
    price = power * 25;
  } else {
    return null;
  }

  return price;
}
